import { Box, CircularProgress } from "@mui/material";
import React from "react";

const Loader = ({ size = 60, minHeight = "700px" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};

export default Loader;
